import { ReactElement } from 'react'

export interface SourceSetEntry {
  media: string
  srcSet: string
}

export function Source(props: { source: SourceSetEntry }): ReactElement {
  return <source  {...props.source} />
}